var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBeauty = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Make-Up-Table-Mirror--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Make Up Table Mirror Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.58a12.07 12.07 0 0 0 10.56 11.07 0.51 0.51 0 0 1 0.44 0.5v0.35a0.5 0.5 0 0 1 -0.5 0.5H4.25a1 1 0 0 0 0 2h15.5a1 1 0 0 0 0 -2H13.5a0.5 0.5 0 0 1 -0.5 -0.5v-0.35a0.5 0.5 0 0 1 0.44 -0.5A12.07 12.07 0 0 0 24 9.58a1 1 0 0 0 -1 -1.08h-1.79a0.5 0.5 0 0 1 -0.5 -0.46A8.74 8.74 0 0 0 3.29 8a0.51 0.51 0 0 1 -0.5 0.46H1a1 1 0 0 0 -1 1.12ZM12 2a6.75 6.75 0 1 1 -6.75 6.75A6.76 6.76 0 0 1 12 2Zm-9.73 9.12a0.48 0.48 0 0 1 0.09 -0.43 0.49 0.49 0 0 1 0.39 -0.19h0.3a0.47 0.47 0 0 1 0.45 0.36 8.76 8.76 0 0 0 17 0 0.49 0.49 0 0 1 0.5 -0.36h0.28a0.49 0.49 0 0 1 0.39 0.19 0.48 0.48 0 0 1 0.09 0.43 10 10 0 0 1 -19.46 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.25A3.75 3.75 0 0 1 12.5 5.5a1 1 0 0 0 0 -2 5.76 5.76 0 0 0 -5.75 5.75 1 1 0 0 0 2 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBeauty);
export default ForwardRef;